import React from 'react';
import Table from '../../../../common/Table';
import { filterMethodCaseInsensitive } from '../../../../../utils/filter-methods';
import Alert from '../../../../common/informative/Alert';
import { DEFAULT_PAGE_SIZE } from '../../../../../config/constants';
import {
  maintenanceChecklistActivityListDefaultProps,
  maintenanceChecklistActivityListPropTypes,
} from '../proptypes/MaintenanceChecklistPropTypes';

const MAINTENANCE_CHECKLIST_ACTIVITY_COLUMNS = [
  {
    Header: 'Código Actividad',
    accessor: 'companyActivityId',
    className: 'text-center',
  },
  {
    Header: 'Actividad',
    accessor: 'activityName',
    className: 'text-center',
  },
  {
    Header: 'Modo de Falla',
    accessor: 'maintenanceFailModeDescription',
    className: 'text-center',
  },
  {
    Header: 'Comentario',
    accessor: 'comment',
    className: 'text-center',
  },
  {
    Header: 'Comentario de Ejecución',
    accessor: 'executionComment',
    className: 'text-center',
  },
];

const formatActivities = (activities) =>
  activities.map(
    ({
      id,
      activity,
      maintenanceFailMode,
      comment,
      maintenancePlanningActivityExecution,
    }) => ({
      id,
      companyActivityId: activity ? activity.companyActivityId : '-',
      activityName: activity ? activity.name : '-',
      maintenanceFailModeDescription: maintenanceFailMode
        ? maintenanceFailMode.description
        : '-',
      comment: comment || '-',
      executionComment:
        maintenancePlanningActivityExecution &&
        maintenancePlanningActivityExecution.comment
          ? maintenancePlanningActivityExecution.comment
          : '-',
    }),
  );

const renderActivityTable = (data) => (
  <Table
    columns={MAINTENANCE_CHECKLIST_ACTIVITY_COLUMNS}
    data={data}
    filterable
    manual={false}
    defaultFilterMethod={filterMethodCaseInsensitive}
    defaultPageSize={data.length > 10 ? DEFAULT_PAGE_SIZE : data.length}
    showPagination={data.length > 10}
  />
);

const MaintenanceChecklistActivityInformationResource = ({
  maintenanceChecklistActivityList,
}) => {
  if (maintenanceChecklistActivityList.length === 0) {
    return (
      <Alert
        type="warning"
        message="Checklist no tiene actividades asignadas."
      />
    );
  }

  const initialActivities = maintenanceChecklistActivityList.filter(
    (activity) => !activity.additional,
  );

  const additionalActivities = maintenanceChecklistActivityList.filter(
    (activity) => activity.additional === true,
  );

  const initialActivitiesData = formatActivities(initialActivities);
  const additionalActivitiesData = formatActivities(additionalActivities);

  return (
    <div>
      {initialActivitiesData.length > 0 ? (
        renderActivityTable(initialActivitiesData)
      ) : (
        <Alert
          type="warning"
          message="Checklist no tiene actividades iniciales."
        />
      )}

      <h4 className="mt-4">Actividades agregadas posteriormente</h4>

      {additionalActivitiesData.length > 0 ? (
        renderActivityTable(additionalActivitiesData)
      ) : (
        <Alert
          type="warning"
          message="No se agregaron actividades posteriormente."
        />
      )}
    </div>
  );
};

MaintenanceChecklistActivityInformationResource.propTypes =
  maintenanceChecklistActivityListPropTypes;

MaintenanceChecklistActivityInformationResource.defaultProps =
  maintenanceChecklistActivityListDefaultProps;

export default MaintenanceChecklistActivityInformationResource;
